export class Action {
  idAction: number;
  name: string;
  orphan: boolean;

  constructor(
    idAction: number,
    name: string,
    orphan: boolean,
  ) {
    this.idAction = idAction;
    this.name = name;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): Action {
    return new Action(
      Number(raw.idAction),
      String(raw.name),
      Boolean(raw.orphan),
    );
  }

  clone(): Action {
    return new Action(
      this.idAction,
      this.name,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idAction: this.idAction,
      name: this.name,
      orphan: this.orphan,
    };
  }
}
